import { render, staticRenderFns } from "./Misreport_loadwise.vue?vue&type=template&id=2351d358"
import script from "./Misreport_loadwise.vue?vue&type=script&lang=js"
export * from "./Misreport_loadwise.vue?vue&type=script&lang=js"
import style0 from "./Misreport_loadwise.vue?vue&type=style&index=0&id=2351d358&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports